<template>
  <div class="modal" :class="{'is-active': isActive}">
    <div class="modal-background" @click="close"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <!--<img class="modal-card-head-icon" :src="app.icon"/>-->
        <p class="modal-card-title">{{app.title}}</p>
        <button class="delete" aria-label="close" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <template v-if="!app.componentName">
          <div class="screenshot-area">
            <img :src="app.screenshot">
          </div>
          <p class="app-description">{{app.description}}</p>
          <div class="features" v-if="app.features">
            <h4>Features</h4>
            <ul>
              <li v-for="(item, i) in app.features" :key="i">{{item}}</li>
            </ul>
          </div>
        </template>
        <template v-if="app.componentName">
          <component ref="component" :is="app.componentName"/>
        </template>
      </section>
      <footer class="modal-card-foot">
        <a
          v-if="app.online"
          class="button is-primary is-small"
          :href="app.online"
          target="online"
        >Online</a>
        <a
          v-if="app.install_eos"
          class="button is-primary is-small"
          target="app_center"
          :href="app.install_eos"
        >AppCenter</a>
        <a
          v-if="app.install_flatpak"
          class="button is-info is-small"
          target="flatpak"
          :href="app.install_flatpak"
        >Flatpak</a>
        <a
          v-if="app.sourcecode"
          class="button is-small"
          target="sourcecode"
          :href="app.sourcecode"
        >SourceCode</a>
      </footer>
    </div>
  </div>
</template>
<script>
import Translit from "../../app/translit/src/App";
import Monitor from "../../app/monitor/src/App";

export default {
  data() {
    return {
      isActive: false,
      app: {},
      componentName: ""
    };
  },
  methods: {
    show(app) {
      this.app = app;
      this.isActive = true;
      this.$emit("opened", app);
      if (app.componentName) {
        this.$nextTick(() => {
          if (typeof this.$refs.component.focus == "function") {
            this.$refs.component.focus();
          }
        });
      }
    },
    close() {
      this.componentName = "";
      this.isActive = false;
      this.$emit("closed");
    }
  },
  components: {
    Translit,
    Monitor
  }
};
</script>
<style scoped>
#app {
  padding: 0;
}

.modal-card {
  width: 760px;
}

.modal-card-head {
  height: 2rem;
  background: #31363b;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid #3daee9;
}

.modal-card-head .delete {
  position: absolute;
  left: 8px;
}

.modal-card-head-icon {
  position: absolute;
}

.modal-card-title {
  text-align: center;
  color: #fff;
  font-size: 1rem;
}

.modal-card-body {
  padding: 0 0 0 0;
  overflow-x: hidden;
}

.modal-card-body .screenshot-area {
  text-align: center;
}

.modal-card-body .features {
  margin: 1rem;
}

.modal-card-body .features li {
  list-style: initial;
  margin-left: 2rem;
}

.modal-card-body .app-description {
  margin-bottom: 1rem;
  text-align: center;
}

.modal-card-foot {
  justify-content: flex-end;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: 0.5rem;
}

.modal-card-foot .button:not(:last-child) {
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/AppDetail.vue